// Shared types for the CARAUTO control app. Mirror the Supabase schema (supabase/schema.sql).

export const PLATE = "AS 11 N 4201"; // registration, shown on the 3D plates and the header

export type WindowId = "fl" | "fr" | "rl" | "rr";
export const WINDOWS: WindowId[] = ["fl", "fr", "rl", "rr"];

export const WINDOW_LABEL: Record<WindowId, string> = {
  fl: "Front L",
  fr: "Front R",
  rl: "Rear L",
  rr: "Rear R",
};

export type CommandType =
  | "lock" | "unlock"
  | "win_up" | "win_down" | "win_vent"
  | "boot"
  | "ac_on" | "ac_off" | `blower_${0 | 1 | 2 | 3 | 4}`
  | "kill_arm" | "kill_disarm"
  | "reserve_arm"
  | "start" | "stop" | "abort"
  | "scene_precool" | "scene_leave" | "scene_park";

export type CommandStatus = "pending" | "sent" | "done" | "failed" | "rejected";

export interface Command {
  id?: number;
  device_id?: string;
  type: CommandType;
  target?: WindowId | "all" | null;
  status?: CommandStatus;
  reason?: string | null;
  created_at?: string;
}

// 0 = fully up/closed, 100 = fully down/open. "vent" ~ 20.
export type WindowPos = number;

export interface CarState {
  online: boolean;
  lastSeen: number | null; // epoch ms
  locked: boolean;
  windows: Record<WindowId, WindowPos>;
  bootOpen: boolean;
  ac: boolean;
  blower: 0 | 1 | 2 | 3 | 4;
  ignition: boolean;
  engineRunning: boolean;
  killArmed: boolean;
  reserveArmed: boolean;
  battV: number;
  cabinC: number;
  neutral: boolean;
  handbrake: boolean;
  doors: Record<WindowId, boolean>; // door-open sensors (true = open)
}

export const INITIAL_STATE: CarState = {
  online: true,
  lastSeen: Date.now(),
  locked: true,
  windows: { fl: 0, fr: 0, rl: 0, rr: 0 },
  bootOpen: false,
  ac: false,
  blower: 0,
  ignition: false,
  engineRunning: false,
  killArmed: false,
  reserveArmed: false,
  battV: 12.4,
  cabinC: 31,
  neutral: false,
  handbrake: true,
  doors: { fl: false, fr: false, rl: false, rr: false },
};
